<template>
    <div>
    </div>
</template>
<script>
    export default {
        name: 'EmptyPanel',
        data () {
            return {
            };
        },
        methods: {
        },
        watch: {
        },
        mounted () {
        },
        destroyed () {
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/tab-panels/empty-panel.vue